import React, { useEffect, useContext, useState, useRef } from 'react'
import { StateController } from '../../App'
import VerticalCenter from '../../layouts/VerticalCenter/VerticalCenter'
import Icon from '../atoms/Icon'
import FaqsFeed from '../organisms/FaqsFeed'

function FaqsModal({
  show,
  setShowModal
}) {
  const { setMdalOpen } = useContext(StateController)
  const [showScrollBtn, setShowScrollBtn] = useState(false)
  const windowRef = useRef(null)
  
   const handleScroll = () => {
      if (windowRef.current) {
        setShowScrollBtn(windowRef.current.scrollTop > 200)
      }
    }
  
    const scrollToTop = () => {
      windowRef.current?.scrollTo({ top: 0, behavior: 'smooth' })
    }

  useEffect(() => {
    setMdalOpen(show);

    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [show]);

  const close = () => {
    setShowModal(false)
  }

  return (
    <div className={`mc-tc-modal ${show && 'mc-tc-modal__opened'} slow_ani`}>
      <div className="mc-tc-modal__overlay slow_ani" onClick={close}></div>
      <div className="mc-tc-modal__center">
        <VerticalCenter>
          <div className="mc-tc-modal__close" onClick={close}>
            <Icon name="close" />
          </div>
          <div className={`mc-tc-modal__center--window slow_ani`} ref={windowRef}  onScroll={handleScroll}>
            <div>
              <div className={`mc-tc-modal__center--window__title`}>
                <h2>Preguntas Frecuentes</h2>
              </div>
              <div className={`mc-tc-modal__center--window__subtitle`}>
                <h3>Campaña “PARA TODO LO QUE QUIERES” 2026</h3>
              </div>

              <div className='mc-static-content faqs'>
                <FaqsFeed
                  faqsType={1}
                  list={[
                    {
                      title: '¿Quiénes pueden participar en la campaña?',
                      content:
                        'Solo clientes titulares de tarjetas Éxito y Carulla Mastercard seleccionados e invitados por Tuya S.A.'
                    },
                    {
                      title: '¿Cómo sé si fui invitado a participar?',
                      content:
                        'Recibirás una comunicación oficial de Tuya S.A. y podrás registrarte en la plataforma con el código único enviado.'
                    },
                    {
                      title: '¿Cuál es la vigencia de la campaña?',
                      content:
                        'Del 15 de abril al 15 de junio de 2026.'
                    },
                    {
                      title: '¿Cómo me registro para participar?',
                      content:
                        'Ingresa a <a href="https://www.todoloquequieres.com.co" target="_blank" rel="noreferrer"> www.todoloquequieres.com.co</a> y regístrate usando el código único que recibiste y tu fecha de nacimiento.'
                    },
                    {
                      title: '¿Qué debo hacer para ganar?',
                      content:
                        `<ul>
                          <li>Acceder a la plataforma <a href="https://www.todoloquequieres.com.co" target="_blank" rel="noreferrer"> www.todoloquequieres.com.co</a> y registrarse utilizando su código único.</li>
                          <li>Cumplir con las metas de facturación asignadas.</li>
                          <li>Estar dentro de los setenta (70) clientes que cumplan el mayor número de veces su meta de facturación asignada en compras en comercios diferentes a Almacenes Éxito o Carulla durante la vigencia de la campaña.</li>
                        </ul>`
                    },
                    {
                      title: '¿Cómo se define mi meta de facturación?',
                      content:
                        'Tu meta es personalizada y se compone de un 20% en compras en Éxito o Carulla y un 80% en otros comercios. Puedes consultarla en la plataforma o en las comunicaciones de la campaña.'
                    },
                    {
                      title: '¿Qué tipo de compras cuentan para la meta?',
                      content:
                        'Solo compras nacionales e internacionales, presenciales o en línea, hechas con tu tarjeta Éxito o Carulla Mastercard. No cuentan avances, compra de seguros ni pagos por PSE.'
                    },
                    {
                      title: '¿Puedo participar con más de una tarjeta?',
                      content:
                        'No, solo puedes participar con la tarjeta seleccionada y comunicada por Tuya S.A.'
                    },
                    {
                      title: '¿Qué pasa si cambio de tarjeta durante la campaña?',
                      content:
                        'Las compras hechas con tu nueva tarjeta pueden tardar hasta 15 días en reflejarse en tu meta.'
                    },
                    {
                      title: '¿Cómo se eligen los ganadores?',
                      content:
                        'Ganan quienes más veces cumplan su meta de facturación en comercios diferentes a Éxito y Carulla y ocupen los primeros lugares del ranking.'
                    },
                    {
                      title: '¿Cuántos ganadores habrá y qué premios hay?',
                      content:
                        'Habrá hasta 70 ganadores. Los premios incluyen un bono para la compra de un carro Renault Kwid, un bono para la compra de una moto Hero Xpulse 200, un Kit Apple que contiene un iPhone, un Apple Watch y unos AirPods, un bono de viajes Éxito por $5 millones, un bono del Éxito por $5 millones y 65 bonos del Éxito de $150.000.'
                    },
                    {
                      title: '¿Cómo me notifican si soy ganador?',
                      content:
                        'Te contactaremos por correo electrónico, mensaje de texto o llamada telefónica dentro de los 15 días hábiles después de terminar la campaña.'
                    },
                    {
                      title: '¿Qué pasa si no respondo a la notificación de ganador?',
                      content:
                        'Si no respondes en 5 días hábiles, el premio pasa al siguiente participante del ranking. Este proceso se repite hasta tres veces.'
                    },
                    {
                      title: '¿Los premios se pueden cambiar por dinero?',
                      content:
                        'No, los premios no son canjeables por dinero ni por otros productos o servicios.'
                    },
                    {
                      title: '¿Qué debo hacer para redimir mi premio?',
                      content:
                        'Sigue las instrucciones que recibirás en la notificación de ganador. Cada premio tiene condiciones específicas de redención y vigencia.'
                    },
                    {
                      title: '¿Qué pasa si tengo dudas sobre mi meta o mis compras?',
                      content:
                        'Puedes consultar tu meta y tus avances en la plataforma <a href="https://www.todoloquequieres.com.co" target="_blank" rel="noreferrer"> www.todoloquequieres.com.co</a>'
                    },
                    {
                      title: '¿Puedo transferir mi premio a otra persona?',
                      content:
                        'No, los premios son personales e intransferibles.'
                    },
                    {
                      title: '¿Qué pasa si soy descalificado?',
                      content:
                        'Tuya S.A. validará internamente los casos de descalificación y comunicará la decisión final.'
                    },
                    {
                      title: '¿Cómo se protegen mis datos personales?',
                      content:
                        'Tus datos serán tratados conforme a la ley colombiana y solo para los fines de la campaña. Puedes consultar la política de tratamiento de datos personales aquí: <a href="https://www.tuya.com.co/proteccion-de-datos-personales" target="_blank" rel="noreferrer">Protección de Datos Personales | Tuya</a>'
                    },
                    {
                      title: '¿Qué beneficios puedo ganar según mi posición en el ranking?',
                      content:
                        'El primer lugar recibe un bono para la compra de un carro Renault Kwid, el segundo un bono para la compra de una moto Hero Xpulse 200, el tercero un Kit Apple que contiene un iPhone, un Apple Watch y unos AirPods, el cuarto un bono de viajes Éxito de $5 millones;, el quinto un bono Éxito de $ 5 millones;, y del sexto al septuagésimo, un bono Éxito de $150.000.'
                    },
                    {
                      title: '¿Cómo funciona el bono de viaje Éxito?',
                      content:
                        'Es un bono para redimir en viajes ofrecidos por Grupo Éxito, válido por un año desde la asignación.'
                    },
                    {
                      title: '¿Cómo funciona el bono Éxito de $150.000?',
                      content:
                        'Es un bono tipo código o cupón, cargado a tu cédula, válido por un año desde la emisión.'
                    },
                    {
                      title: '¿Qué pasa si no uso el bono dentro de su vigencia?',
                      content:
                        'Pierdes el derecho a redimirlo y no se podrá solicitar uno nuevo.'
                    },
                    {
                      title: '¿Qué sucede si hay un empate en el ranking?',
                      content:
                        'El beneficio se otorga al participante con mayor cantidad de transacciones con su tarjeta durante la campaña.'
                    },
                    {
                      title: '¿Qué gastos no están incluidos en los premios?',
                      content:
                        'Gastos de traslado, manutención, trámites adicionales, impuestos no especificados y cualquier gasto no detallado en los términos y condiciones.'
                    },
                    {
                      title: '¿Puedo participar si soy empleado de Tuya S.A.?',
                      content:
                        'Empleados de Tuya S.A. solo pueden optar por el bono Éxito de $150.000.'
                    },
                    {
                      title: '¿Cómo puedo consultar mi meta individual?',
                      content:
                        'Puedes verla en las comunicaciones enviadas por Tuya S.A. y en la plataforma de la campaña <a href="https://www.todoloquequieres.com.co" target="_blank" rel="noreferrer"> www.todoloquequieres.com.co</a>'
                    },
                    {
                      title: '¿Dónde puedo consultar los términos y condiciones completos?',
                      content:
                        'En la página web de la campaña <a href="https://www.todoloquequieres.com.co" target="_blank" rel="noreferrer"> www.todoloquequieres.com.co</a>'
                    }
                  ]}
                />
              </div>
            </div>
            {showScrollBtn && (
                <a
                  onClick={scrollToTop}
                  className="mc-tc-modal__scroll-top"
                >
                  <img src="assets/images/button_up.svg" alt="button_up" />
                </a>
              )}
          </div>


        </VerticalCenter>
      </div>
    </div>
  )
}

export default FaqsModal